<div class="col-lg-12" *ngFor="let field of fields; let i = index">
  <div class="col-lg-12 col-md-12 col-sm-12 spacer-bottom-xs"></div>
  
      <app-generic-field [form]="form" [fieldConfig]="field" [uppercaseText]="uppercaseText" [isServiceProvider]="isServiceProvider"></app-generic-field>
      <mat-error *ngIf="formErrors[field.FieldCode]" class="font75per">
        {{formErrors[field.FieldCode]}}
      </mat-error>
 

</div>